/*
 * @created: Wednesday, 1st April 2020 2:49:29 pm
 * @author: github.com/huangbinjie
 * @file: 灰色
 *
 * Copyright 2020 Qiniu
 */
var Grey;
(function (Grey) {
    Grey["grey1"] = "#FFFFFF";
    Grey["grey2"] = "#FAFAFA";
    Grey["grey3"] = "#F5F5F5";
    Grey["grey4"] = "#EEEEEE";
    Grey["grey5"] = "#E5E5E5";
    Grey["grey6"] = "#D9D9D9";
    Grey["grey7"] = "#BFBFBF";
    Grey["grey8"] = "#999999";
    Grey["grey9"] = "#666666";
    Grey["grey10"] = "#333333"; // 主标题、正文
})(Grey || (Grey = {}));
export default Grey;
//# sourceMappingURL=grey.js.map